import React from 'react';
import cn from 'classnames';
import { Url } from '@wix/da-url';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import ModalFooterMobile from '@wix/da-ds/pkg/modals/dsPresets/ModalFooterMobile';
import BuyCoreBrandedButton from '@wix/da-shared-react/pkg/Button/core/dsPresets/BuyCoreBrandedButton';

import s from './UnlockWithCoreUpsellModal.scss';

export interface Props {
  title: React.ReactNode;
  body: React.ReactNode;
  /** text/content of BuyCoreButton */
  cta: React.ReactNode;
  /** BuyCoreButtonBiEvent's referral_info */
  referralType?: ReferralType;
  /** used as BuyCoreButton's href */
  referer?: string;
  className?: string;
  requestClose: () => void;
}

/** Dialog with a single, buy-core button. Used for core feature blocking */
const UnlockWithCoreUpsellModal: React.FC<Props> = ({
  title,
  body,
  cta,
  referralType = ReferralType.SUBMIT,
  referer = Url.studio(),
  className,
  requestClose,
}) => {
  return (
    <Modal
      className={cn(s['root'], className)}
      isOpen
      onRequestClose={requestClose}
      isFullscreen={false}
      headerClassName={s['header']}
      heading={<div className={s['title']}>{title}</div>}
      footer={
        <ModalFooterMobile
          className={s['footer']}
          primaryButton={
            <BuyCoreBrandedButton
              size="large"
              withMobileDefaultLabel={false}
              rel="noopener"
              referer={referer}
              biData={BiData<BuyCoreButtonBiEvent>({
                evid: 375,
                referral_info: referralType,
              })}
            >
              {cta}
            </BuyCoreBrandedButton>
          }
        />
      }
      contentClassName={s['body']}
    >
      {body}
    </Modal>
  );
};
UnlockWithCoreUpsellModal.displayName = 'UnlockWithCoreUpsellModal';

export default UnlockWithCoreUpsellModal;
